import { CanvasCreator } from "./canvas-creator";
import { GraphicCanvas } from "../../../../../web-graphics";
import { GraphicCanvasWithFps } from "../../../../../web-visualizator";

export class FpsCanvasCreator extends CanvasCreator {
  constructor(commonSettings, viewObjectCreators, idGenerator) {
    super(commonSettings, viewObjectCreators, idGenerator);
  }

  create(settings) {
    let calllbackArray = this.callbacks.get("beforeCreate");
    calllbackArray.forEach(callback => callback(settings, this));
    CanvasCreator.prepareSettings(settings);
    let canvas = undefined;
    if (settings.withFpsMeter ?? false) {
      canvas = new GraphicCanvasWithFps(settings);
    } else {
      canvas = new GraphicCanvas(settings);
    }
    CanvasCreator.createItems(settings.items, this.viewObjectCreators, canvas, this.idGenerator, this);
    calllbackArray = this.callbacks.get("afterCreate");
    calllbackArray.forEach(callback => callback(canvas, settings, this));
    return canvas;
  }
}
